import type * as THREE from 'three';

/**
 * Checks if the given object is a THREE.OrthographicCamera agnostic three instance.
 */
export const isOrthographicCamera = (object: unknown): object is THREE.OrthographicCamera => {
  return !!(object && (object as THREE.OrthographicCamera).isOrthographicCamera);
};

/**
 * Checks if the given object is a THREE.PerspectiveCamera agnostic three instance.
 */
export const isPerspectiveCamera = (object: unknown): object is THREE.PerspectiveCamera => {
  return !!(object && (object as THREE.PerspectiveCamera).isPerspectiveCamera);
};
